'use client';

import { type ComponentProps } from 'react';

import { type InputOpts } from '../../types';
import { InternationalPhoneInput } from '../inputs-core';

interface SmsPhoneInputProps extends InputOpts, ComponentProps<typeof InternationalPhoneInput> {
  shouldAllowInternational?: boolean;
}

const SmsPhoneInput = ({
  shouldAllowInternational,
  defaultCountry = 'US',
  ...props
}: SmsPhoneInputProps) => {
  return (
    <InternationalPhoneInput
      {...props}
      defaultCountry={defaultCountry}
      shouldEnableCountryCallingCode={shouldAllowInternational}
    />
  );
};

export { SmsPhoneInput, type SmsPhoneInputProps };
